import { IAttachments } from './../../pcr/store/pcr.types'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector, getUserIdSelector } from '../../user/selectors'
import { getSignaturesSelector } from '../selectors/getSignatures.selector'
import { getAttachments, setAttachmentsList } from '../store/signatures.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { ISignaturesState } from '../store/signatures.types'
import Logger from '../../../services/logger.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* deleteAttachment() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const userId: string = yield select(getUserIdSelector)
  const pcrId: string = yield select(getPcrIdSelector)
  const signaturesState: ISignaturesState = yield select(getSignaturesSelector)
  const { attachmentId, attachmentType } = signaturesState
  if (!pcrId) {
    return
  }
  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (attachmentType === 'signature') {
      if (pcrDoc._attachments) {
        if (attachmentId) {
          // deleting attachment from pcrDoc
          if (attachmentId in pcrDoc._attachments) {
            delete pcrDoc._attachments[attachmentId as keyof IAttachments]
          }
          if (signaturesState.attachments) {
            // deleting attachment from signature state
            signaturesState.attachments = signaturesState.attachments.filter((data) => data.key !== attachmentId)
            // saving in signature state
            yield put(setAttachmentsList(signaturesState.attachments))
          }

          if (!Object.keys(pcrDoc._attachments).length) {
            delete pcrDoc._attachments
          }

          Logger.info(
            `Attachment: ${attachmentId} in PCR: ${pcrId} deleted by user: ${userId} in service: ${serviceId}`
          )
        }
        yield call([pcrDocsService, pcrDocsService.savePCR], { ...pcrDoc, signatures: signaturesState })
      }
    } else if (attachmentType === 'cameraAttachment') {
      if (pcrDoc._fileAttachments) {
        const index = pcrDoc._fileAttachments.findIndex((item) => item.id === attachmentId)
        if (index >= 0) {
          pcrDoc._fileAttachments.splice(index, 1)
          Logger.info(
            `Attachment: ${attachmentId} in PCR: ${pcrId} deleted by user: ${userId} in service: ${serviceId}`
          )
          yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)
          yield put(getAttachments())
        }
      }
    }
  } catch (e) {
    yield put(throwPcrException(e))
  }
}

export function* deleteAttachmentSaga() {
  yield takeLatest([SignaturesConstants.DELETE_ATTACHMENT], performWithMutexHOG, deleteAttachment)
}
